import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BitlyService } from 'src/app/services/bitly.service';
import { DataService } from 'src/app/services/data.service';
import { SecurityService } from 'src/app/services/security.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-share-link-credit',
  templateUrl: './share-link-credit.component.html',
  styleUrls: ['./share-link-credit.component.scss']
})
export class ShareLinkCreditComponent implements OnInit, OnDestroy {
  @Input() pageUrl!: string
  @Input() url!: any
  @Input() carTitle!: string
  @Input() deadlineSelect!: any
  @Input() dataQuoter!: any
  @Input() metaUrl!: any;

  showDetails: boolean = false
  showButtons: boolean = true
  shareUrl: string = ''
  copyUrl: string = ''

  subscriptionShow!: Subscription;
  
  constructor(
    private securityService: SecurityService,
    private dataService: DataService,
    private bitlyService: BitlyService
  ) {
    this.subscriptionShow = this.dataService.getShowShareLink().subscribe(res => {
      this.showDetails = res
    })
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.showButtons = false;
    }, 3000);
  }

  ngOnDestroy(): void {
    this.subscriptionShow.unsubscribe();
  }

  generateLink() {
    let dataEncrypt;
    let dataMeta = ''

    const { concept, period } = this.deadlineSelect;
    const data = { ...this.dataQuoter, deadlineConcept: concept, dealinePeriod: period, isAfin: this.dataQuoter.quoterType === 'AFIN' || this.dataQuoter.quoterType === 'RR'}
    dataEncrypt = this.securityService.encryptData(data, true);
    dataMeta = '&share_title=' + encodeURIComponent(this.metaUrl.title) + '&share_desc=' + encodeURIComponent(this.metaUrl.desc)

    if(this.metaUrl.img)
      dataMeta += '&share_img=' + encodeURIComponent(this.metaUrl.img)

    this.copyUrl = environment.keycloak.redirectUri + this.pageUrl + dataEncrypt + dataMeta
    this.bitlyService.generateShortUrl({long_url: this.copyUrl }).subscribe({
      next: (res: any) => {
        this.shareUrl = res.link;
        this.showButtons = true;
        this.showDetails = true
      },
      error: (err) => {
        console.log(err)
        this.shareUrl = this.copyUrl;
        this.showButtons = true;
        this.showDetails = true
      }
    });
  }

}
